import { memo } from 'react'

import HeaderOverhaul from '@/components/elements/headerOverhaul'

import CustomImage from '../../elements/images/image'

const InnovationAwards = ({ data }) => {
  const { header, awardImage } = data

  return (
    <div className="innovation-awards-wrapper">
      <HeaderOverhaul header={header} subtitle />
      <div className="innovation-awards-image-container">
        <CustomImage
          media={awardImage.data.attributes}
          width={awardImage.data.attributes.width}
          height={awardImage.data.attributes.height}
          objectFit="cover"
          shimmer
        />
      </div>
    </div>
  )
}

export default memo(InnovationAwards)
